<!--
 * @Description:
 * @Autor: songzhu
 * @LastEditors: songzhu
 * @LastEditTime: 2022-02-21 10:01:43
-->
<script>
const fileSite = 'https://file.szmdzh.com';
const testSite = 'https://ss.szmdzh.com';
const devSite = 'https://ss.szmdzh.com';
const socketDevSite = 'ss.szmdzh.com'
const socketTestSite = 'ss.szmdzh.com'
export default {
    fileSite,
    testSite,
    devSite,
    socketDevSite,
    socketTestSite
}
</script>



// WEBPACK FOOTER //
// src/components/global.vue